var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#0d0d0d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.755 -0.755)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(1.755 1.755)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 4,
    y2: 4,
    transform: "translate(7.755 7.755)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4,
    y2: 4,
    transform: "translate(7.755 7.755)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectDownload);
export default __webpack_public_path__ + "static/media/direct-download.324df59fe4f1b5607cf92dd96dc3c91f.svg";
export { ForwardRef as ReactComponent };